import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProgramDoctorsAddPage } from './program-doctors-add';
import { MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, MatAutocompleteModule } from '@angular/material';

@NgModule({
  declarations: [
    ProgramDoctorsAddPage,
  ],
  imports: [
    IonicPageModule.forChild(ProgramDoctorsAddPage),
    MatFormFieldModule, MatInputModule, MatSelectModule, MatButtonModule, MatAutocompleteModule
  ],
})
export class ProgramDoctorsAddPageModule {}



// WEBPACK FOOTER //
// ./src/pages/program-doctors-add/program-doctors-add.module.ts